<template>
<div class="p-4 home-main-div">
    <br>
    <h1 class="total-count"> {{ totalData }}</h1>
    <h3 class="total-count-desc pt-2">Orang</h3>
    <h1 class="total-count-desc pt-2">Telah Berkomitmen Bersama </h1>
    <h1 class="total-count-desc pt-2">Dalam <span class="desc-highlight"> Melawan Kanker </span> </h1>
    <br>
    <br>
    <h5>Geser untuk melihat jumlah partisipan setiap kanker</h5>
    <div class="cancer-item-container p-4">
        <div v-for="item in stats" v-bind:key="item.id" :class="item.classString">
            <div style="display:flex;">
                <h5>{{ item.cancerName }}</h5>
            </div>
            <div style="display:flex;">
                <!-- <h1 class="color-1 mr-4">✋</h1> -->
                <img v-if="item.handColorIsBlack" :src="require('../assets/hs-black.png')" class="biglogo mr-3" />
                <img v-if="!item.handColorIsBlack" :src="require('../assets/hs-white.png')" class="biglogo mr-3" />
            <h1>{{ item.number }}</h1>
            </div>
        </div>
    </div>
    <br>

    <div class="form-container p-4 mb-2" v-if="state==1">
        <h2> <b>Terima Kasih Telah Berpartisipasi!</b></h2>
        <br>
        <div style="display:flex;" class="justify-content-center">
            <button v-if="previewImage!=null" type="button" class="btn btn-primary btn-lg p-3 mr-4" @click="downloadPoster">Download Poster</button>
            <button type="button" class="btn btn-primary btn-lg p-3" @click="downloadHandSign">Download Handsign</button>
        </div>
    </div>
    <div class="form-container p-4" v-if="state==0">
        <br>
        <h2> <b>Yuk, Ikut berpartisipasi!</b></h2>
        <br>
        <div class="row">
            <div class="col-lg-4 col-xs-12 p-4">
                <div class="form-group">
                    <h4 class="text-left">Email</h4>
                    <input v-model="formData.email" type="email" class="form-control form-control-lg" id="exampleFormControlInput1" >
                </div>
            </div>
            <div class="col-lg-4 col-xs-12 p-4">
                <div class="form-group">
                    <h4 class="text-left">Nama Lengkap</h4>
                    <input v-model="formData.fullName" type="email" class="form-control form-control-lg" id="exampleFormControlInput1" >
                </div>
            </div>
            <div class="col-lg-4 col-xs-12 p-4">
                <div class="form-group">
                    <h4 class="text-left">Nama Untuk Ditampilkan</h4>
                    <input v-model="formData.nickName" type="email" class="form-control form-control-lg" id="exampleFormControlInput1" placeholder="maks 15 karakter" maxlength="15">
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-6 col-xs-12 p-4">
                <div class="form-group">
                    <h4 class="text-left">Institusi</h4>
                    <input v-model="formData.institution" type="email" class="form-control form-control-lg" id="exampleFormControlInput1" placeholder="maks 15 karakter" maxlength="15">
                </div>
            </div>
            <div class="col-lg-6 col-xs-12 p-4">
                <div class="form-group">
                    <h4 class="text-left">Domisili</h4>
                    <!-- <input v-model="formData.domicile" type="email" class="form-control form-control-lg" id="exampleFormControlInput1" maxlength="15"> -->
                    <select v-model="formData.domicile" class="form-control form-control-lg">
                        <option v-for="item in province" :value="item" :key="item">{{ item }}</option>
                    </select>
                </div>
            </div>
        </div>
        <div v-if="isErrorForm" class="alert alert-danger mb-4" role="alert">
        {{errorMessageForm}}
        </div>
        <h5>Geser untuk memilih jenis kanker</h5>
        <div class="cancer-item-container p-4">
            <div id="op-26" class="option-item option-26 p-3 m-2" @click="setOption('op-26')">
                <!-- <h4>✋ </h4> -->
                <img :src="require('../assets/hs-black.png')" class="minilogo mr-2" />
                <h4>All Cancer</h4>
            </div>
            <div id="op-1" class="option-item option-1 p-3 m-2"  @click="setOption('op-1')">
                <!-- <h4>✋ </h4> -->
                <img :src="require('../assets/hs-black.png')" class="minilogo mr-2" />
                <h4>Bladder</h4>
            </div>
            <div id="op-2" class="option-item option-2 p-3 m-2" @click="setOption('op-2')">
                <!-- <h4>✋ </h4> -->
                <img :src="require('../assets/hs-black.png')" class="minilogo mr-2" />
                <h4>Brain</h4>
            </div>
            <div id="op-3" class="option-item option-3 p-3 m-2" @click="setOption('op-3')">
                <!-- <h4>✋ </h4> -->
                <img :src="require('../assets/hs-white.png')" class="minilogo mr-2" />
                <h4>Breast</h4>
            </div>
            <div id="op-4" class="option-item option-4 p-3 m-2" @click="setOption('op-4')">
                <!-- <h4>✋ </h4> -->
                <img :src="require('../assets/hs-white.png')" class="minilogo mr-2" />
                <h4>Cervical</h4>
            </div>
            <div id="op-5" class="option-item option-5 p-3 m-2"  @click="setOption('op-5')">
                <!-- <h4>✋ </h4> -->
                <img :src="require('../assets/hs-black.png')" class="minilogo mr-2" />
                <h4>Childhood</h4>
            </div>
            <div id="op-6" class="option-item option-6 p-3 m-2"  @click="setOption('op-6')">
                <!-- <h4>✋ </h4> -->
                <img :src="require('../assets/hs-white.png')" class="minilogo mr-2" />
                <h4>Colon</h4>
            </div>
            <div id="op-7" class="option-item option-7 p-3 m-2" @click="setOption('op-7')">
                <!-- <h4>✋ </h4> -->
                <img :src="require('../assets/hs-black.png')" class="minilogo mr-2" />
                <h4>Esophageal</h4>
            </div>
            <div id="op-8" class="option-item option-8 p-3 m-2" @click="setOption('op-8')">
                <!-- <h4>✋ </h4> -->
                <img :src="require('../assets/hs-white.png')" class="minilogo mr-2" />
                <h4>Head & Neck</h4>
            </div>
            <div id="op-9" class="option-item option-9 p-3 m-2" @click="setOption('op-9')">
                <!-- <h4>✋ </h4> -->
                <img :src="require('../assets/hs-black.png')" class="minilogo mr-2" />
                <h4>Kidney</h4>
            </div>
            <div id="op-10" class="option-item option-10 p-3 m-2" @click="setOption('op-10')">
                <!-- <h4>✋ </h4> -->
                <img :src="require('../assets/hs-black.png')" class="minilogo mr-2" />
                <h4>Leukemia</h4>
            </div>
            <div id="op-11" class="option-item option-11 p-3 m-2" @click="setOption('op-11')">
                <!-- <h4>✋ </h4> -->
                <img :src="require('../assets/hs-white.png')" class="minilogo mr-2" />
                <h4>Liver</h4>
            </div>
            <div id="op-12" class="option-item option-12 p-3 m-2" @click="setOption('op-12')">
                <!-- <h4>✋ </h4> -->
                <img :src="require('../assets/hs-black.png')" class="minilogo mr-2" />
                <h4>Lung</h4>
            </div>
            <div id="op-13" class="option-item option-13 p-3 m-2" @click="setOption('op-13')">
                <!-- <h4>✋ </h4> -->
                <img :src="require('../assets/hs-black.png')" class="minilogo mr-2" />
                <h4>Lymphoma</h4>
            </div>
            <div id="op-14" class="option-item option-14 p-3 m-2" @click="setOption('op-14')">
                <!-- <h4>✋ </h4> -->
                <img :src="require('../assets/hs-white.png')" class="minilogo mr-2" />
                <h4>Melanoma</h4>
            </div>
            <div id="op-15" class="option-item option-15 p-3 m-2" @click="setOption('op-15')">
                <!-- <h4>✋ </h4> -->
                <img :src="require('../assets/hs-white.png')" class="minilogo mr-2" />
                <h4>Multiple Myeloma</h4>
            </div>
            <div id="op-16" class="option-item option-16 p-3 m-2" @click="setOption('op-16')">
                <!-- <h4>✋ </h4> -->
                <img :src="require('../assets/hs-white.png')" class="minilogo mr-2" />
                <h4>Ovarian</h4>
            </div>
            <div id="op-17" class="option-item option-17 p-3 m-2" @click="setOption('op-17')">
                <!-- <h4>✋ </h4> -->
                <img :src="require('../assets/hs-white.png')" class="minilogo mr-2" />
                <h4>Pancreatic</h4>
            </div>
            <div id="op-18" class="option-item option-18 p-3 m-2" @click="setOption('op-18')">
                <!-- <h4>✋ </h4> -->
                <img :src="require('../assets/hs-black.png')" class="minilogo mr-2" />
                <h4>Prostate</h4>
            </div>
            <div id="op-19" class="option-item option-19 p-3 m-2" @click="setOption('op-19')">
                <!-- <h4>✋ </h4> -->
                <img :src="require('../assets/hs-black.png')" class="minilogo mr-2" />
                <h4>Stomach</h4>
            </div>
            <div id="op-20" class="option-item option-20 p-3 m-2" @click="setOption('op-20')">
                <!-- <h4>✋ </h4> -->
                <img :src="require('../assets/hs-white.png')" class="minilogo mr-2" />
                <h4>Testicular</h4>
            </div>
            <div id="op-21" class="option-item option-21 p-3 m-2" @click="setOption('op-21')">
                <!-- <h4>✋ </h4> -->
                <img :src="require('../assets/hs-white.png')" class="minilogo mr-2" />
                <h4>Thyroid</h4>
            </div>
            <div id="op-22" class="option-item option-22 p-3 m-2" @click="setOption('op-22')">
                <!-- <h4>✋ </h4> -->
                <img :src="require('../assets/hs-black.png')" class="minilogo mr-2" />
                <h4>Uterine</h4>
            </div>
            <div id="op-23" class="option-item option-23 p-3 m-2" @click="setOption('op-23')">
                <!-- <h4>✋ </h4> -->
                <img :src="require('../assets/hs-white.png')" class="minilogo mr-2" />
                <h4>Honors</h4>
            </div>
            <div id="op-24" class="option-item option-24 p-3 m-2" @click="setOption('op-24')">
                <!-- <h4>✋ </h4> -->
                <img :src="require('../assets/hs-white.png')" class="minilogo mr-2" />
                <h4>Leiomyosarcoma</h4>
            </div>
            <div id="op-25" class="option-item option-25 p-3 m-2" @click="setOption('op-25')">
                <!-- <h4>✋ </h4> -->
                <img :src="require('../assets/hs-black.png')" class="minilogo mr-2" />
                <h4>Sarcoma</h4>
            </div>
        </div>
        <div v-if="isErrorType" class="alert alert-danger mb-4" role="alert">
        {{errorMessageType}}
        </div>
        <br>
        <h4>Pilih foto apabila anda ingin membuat poster dengan foto</h4>
        <input class="btn" type="file" accept="image/jpeg" @change=uploadImage />
        <br>
        <br>
        <button type="button" class="btn btn-primary btn-lg p-3" @click="submitData">Submit</button>
        <br>
    </div>

    <div class="result-container p-4 mb-2" v-if="state==1 && previewImage!=null" >
        <div id="capture" class="frame">
            <p class="greetings text-white" v-if="isTextWhite && !isThyroid"> {{ formData.nickName }} - {{ formData.institution }} - {{ formData.domicile }}</p>
            <p class="greetings text-black" v-if="!isTextWhite && !isThyroid"> {{ formData.nickName }} - {{ formData.institution }} - {{ formData.domicile }}</p>
            <img v-if="currentClicked=='op-1'" :src="require('../assets/1.png')" class="twibbon" />
            <img v-if="currentClicked=='op-2'" :src="require('../assets/2.png')" class="twibbon" />
            <img v-if="currentClicked=='op-3'" :src="require('../assets/3.png')" class="twibbon" />
            <img v-if="currentClicked=='op-4'" :src="require('../assets/4.png')" class="twibbon" />
            <img v-if="currentClicked=='op-5'" :src="require('../assets/5.png')" class="twibbon" />
            <img v-if="currentClicked=='op-6'" :src="require('../assets/6.png')" class="twibbon" />
            <img v-if="currentClicked=='op-7'" :src="require('../assets/7.png')" class="twibbon" />
            <img v-if="currentClicked=='op-8'" :src="require('../assets/8.png')" class="twibbon" />
            <img v-if="currentClicked=='op-9'" :src="require('../assets/9.png')" class="twibbon" />
            <img v-if="currentClicked=='op-10'" :src="require('../assets/10.png')" class="twibbon" />
            <img v-if="currentClicked=='op-11'" :src="require('../assets/11.png')" class="twibbon" />
            <img v-if="currentClicked=='op-12'" :src="require('../assets/12.png')" class="twibbon" />
            <img v-if="currentClicked=='op-13'" :src="require('../assets/13.png')" class="twibbon" />
            <img v-if="currentClicked=='op-14'" :src="require('../assets/14.png')" class="twibbon" />
            <img v-if="currentClicked=='op-15'" :src="require('../assets/15.png')" class="twibbon" />
            <img v-if="currentClicked=='op-16'" :src="require('../assets/16.png')" class="twibbon" />
            <img v-if="currentClicked=='op-17'" :src="require('../assets/17.png')" class="twibbon" />
            <img v-if="currentClicked=='op-18'" :src="require('../assets/18.png')" class="twibbon" />
            <img v-if="currentClicked=='op-19'" :src="require('../assets/19.png')" class="twibbon" />
            <img v-if="currentClicked=='op-20'" :src="require('../assets/20.png')" class="twibbon" />
            <img v-if="currentClicked=='op-21'" :src="require('../assets/21.png')" class="twibbon" />
            <img v-if="currentClicked=='op-22'" :src="require('../assets/22.png')" class="twibbon" />
            <img v-if="currentClicked=='op-23'" :src="require('../assets/23.png')" class="twibbon" />
            <img v-if="currentClicked=='op-24'" :src="require('../assets/24.png')" class="twibbon" />
            <img v-if="currentClicked=='op-25'" :src="require('../assets/25.png')" class="twibbon" />
            <img v-if="currentClicked=='op-26'" :src="require('../assets/26.png')" class="twibbon" />
            <img :src="previewImage" class="uploading-image" id="id-foto" />
        </div>
    </div>
    <div class="result-container-2 p-4" v-if="state==1">
        <div id="capture2" class="frame2">
            <!-- <p class="greetings2 big text-black" v-if="isHsBig && isTextWhite && !isSplit"> {{ spacedData.nickName }} <br> {{ spacedData.institution }} <br> {{ spacedData.domicile }}</p> -->
            <!-- <p class="greetings2 big text-white" v-if="isHsBig && !isTextWhite && !isSplit"> {{ spacedData.nickName }} <br> {{ spacedData.institution }} <br> {{ spacedData.domicile }}</p>
            <p class="greetings2 small text-black" v-if="!isHsBig && isTextWhite && !isSplit"> {{ spacedData.nickName }} <br> {{ spacedData.institution }} <br> {{ spacedData.domicile }}</p>
            <p class="greetings2 small text-white" v-if="!isHsBig && !isTextWhite && !isSplit"> {{ spacedData.nickName }} <br> {{ spacedData.institution }} <br> {{ spacedData.domicile }}</p>
            
            <div class="greetings2 big is-split" v-if="isHsBig && isSplit"> {{ spacedData.nickName }} <br> {{ spacedData.institution }} <br> {{ spacedData.domicile }}</div>
            <div class="greetings2 small is-split" v-if="!isHsBig && isSplit"> {{ spacedData.nickName }} <br> {{ spacedData.institution }} <br> {{ spacedData.domicile }}</div> -->

            <p class="hs-text text-white" v-if="!isTextWhite"><b>{{ spacedData.nickName }} <br> {{ spacedData.institution }} <br> {{ spacedData.domicile }}</b></p>
            <p class="hs-text text-black" v-if="isTextWhite"><b>{{ spacedData.nickName }} <br> {{ spacedData.institution }} <br> {{ spacedData.domicile }}</b></p>

            <!-- <p class="hs-text text-white" v-if="!isTextWhite"><b> Hasanah Nur <br> Nama Organisasi <br> Kep. Bangka Belitung</b></p> -->
            <!-- <p class="hs-text text-black" v-if="isTextWhite"><b>Kep. Bangka Belitungg <br> Kep. Bangka Belitungg <br> Kep. Bangka Belitungg</b></p> -->

            <img v-if="currentClicked=='op-1'" :src="require('../assets/hands/1.png')" class="uploading-image-hands" id="id-hands" />
            <img v-if="currentClicked=='op-2'" :src="require('../assets/hands/2.png')" class="uploading-image-hands" id="id-hands" />
            <img v-if="currentClicked=='op-3'" :src="require('../assets/hands/3.png')" class="uploading-image-hands" id="id-hands" />
            <img v-if="currentClicked=='op-4'" :src="require('../assets/hands/4.png')" class="uploading-image-hands" id="id-hands" />
            <img v-if="currentClicked=='op-5'" :src="require('../assets/hands/5.png')" class="uploading-image-hands" id="id-hands" />
            <img v-if="currentClicked=='op-6'" :src="require('../assets/hands/6.png')" class="uploading-image-hands" id="id-hands" />
            <img v-if="currentClicked=='op-7'" :src="require('../assets/hands/7.png')" class="uploading-image-hands" id="id-hands" />
            <img v-if="currentClicked=='op-8'" :src="require('../assets/hands/8.png')" class="uploading-image-hands" id="id-hands" />
            <img v-if="currentClicked=='op-9'" :src="require('../assets/hands/9.png')" class="uploading-image-hands" id="id-hands" />
            <img v-if="currentClicked=='op-10'" :src="require('../assets/hands/10.png')" class="uploading-image-hands" id="id-hands" />
            <img v-if="currentClicked=='op-11'" :src="require('../assets/hands/11.png')" class="uploading-image-hands" id="id-hands" />
            <img v-if="currentClicked=='op-12'" :src="require('../assets/hands/12.png')" class="uploading-image-hands" id="id-hands" />
            <img v-if="currentClicked=='op-13'" :src="require('../assets/hands/13.png')" class="uploading-image-hands" id="id-hands" />
            <img v-if="currentClicked=='op-14'" :src="require('../assets/hands/14.png')" class="uploading-image-hands" id="id-hands" />
            <img v-if="currentClicked=='op-15'" :src="require('../assets/hands/15.png')" class="uploading-image-hands" id="id-hands" />
            <img v-if="currentClicked=='op-16'" :src="require('../assets/hands/16.png')" class="uploading-image-hands" id="id-hands" />
            <img v-if="currentClicked=='op-17'" :src="require('../assets/hands/17.png')" class="uploading-image-hands" id="id-hands" />
            <img v-if="currentClicked=='op-18'" :src="require('../assets/hands/18.png')" class="uploading-image-hands" id="id-hands" />
            <img v-if="currentClicked=='op-19'" :src="require('../assets/hands/19.png')" class="uploading-image-hands" id="id-hands" />
            <img v-if="currentClicked=='op-20'" :src="require('../assets/hands/20.png')" class="uploading-image-hands" id="id-hands" />
            <img v-if="currentClicked=='op-21'" :src="require('../assets/hands/21.png')" class="uploading-image-hands" id="id-hands" />
            <img v-if="currentClicked=='op-22'" :src="require('../assets/hands/22.png')" class="uploading-image-hands" id="id-hands" />
            <img v-if="currentClicked=='op-23'" :src="require('../assets/hands/23.png')" class="uploading-image-hands" id="id-hands" />
            <img v-if="currentClicked=='op-24'" :src="require('../assets/hands/24.png')" class="uploading-image-hands" id="id-hands" />
            <img v-if="currentClicked=='op-25'" :src="require('../assets/hands/25.png')" class="uploading-image-hands" id="id-hands" />
            <img v-if="currentClicked=='op-26'" :src="require('../assets/hands/26.png')" class="uploading-image-hands" id="id-hands" />
            <img :src="require('../assets/handsign_frame.png')" class="uploading-image" id="id-hands" />
        </div>
    </div>
</div>
</template>

<script>
import domtoimage from 'dom-to-image';
import axios from "axios";
export default {
    name: 'HomePage',
    props: {
        msg: String
    },
    data() {
        return {
            previewImage: null,
            imgsize: 0,
            state: 0,
            formData: {
                type: 0,
                fullName: "",
                nickName: "",
                institution: "",
                domicile: "",
                email:"",
            },
            spacedData:{
                nickName: "",
                institution: "",
                domicile: ""
            },
            currentClicked: "op-3",
            twibbonUrl: "",
            stats: [],
            cancerNames: {
                "1":"Bladder", 
                "2":"Brain", 
                "3":"Breast", 
                "4":"Cervical", 
                "5":"Childhood", 
                "6":"Colon", 
                "7":"Esophageal", 
                "8":"Head & Neck", 
                "9":"Kidney", 
                "10":"Leukemia", 
                "11":"Liver", 
                "12":"Lung", 
                "13":"Lymphoma", 
                "14":"Melanoma", 
                "15":"Multiple Myeloma", 
                "16":"Ovarian", 
                "17":"Pancreatic", 
                "18":"Prostate", 
                "19":"Stomach", 
                "20":"Testicular", 
                "21":"Thyroid", 
                "22":"Uterine", 
                "23":"Honors", 
                "24":"Leiomyosarcoma", 
                "25":"Sarcoma", 
                "26":"All Cancer"
            },
            handIconColorBlack: {
                "1":true, 
                "2":true, 
                "3":true, 
                "4":false, 
                "5":true, 
                "6":false, 
                "7":true, 
                "8":false, 
                "9":true, 
                "10":true, 
                "11":false, 
                "12":true, 
                "13":true, 
                "14":false, 
                "15":false, 
                "16":false, 
                "17":false, 
                "18":true, 
                "19":true, 
                "20":false, 
                "21":false, 
                "22":true, 
                "23":false, 
                "24":false, 
                "25":true, 
                "26":true
            },
            isErrorForm:false,
            isErrorType:false,
            errorMessageForm:"Data Anda belum lengkap",
            errorMessageType:"Anda belum memilih jenis kanker",
            isHsBig: false,
            maxChar: 0,
            totalData: 0,
            result: false,
            province: [
                "DI Yogyakarta",
                "Sumatra Utara",
                "Sumatra Selatan",
                "Sumatra Barat",
                "Sulawesi Utara",
                "Sulawesi Tenggara",
                "Sulawesi Tengah",
                "Sulawesi Selatan",
                "Sulawesi Barat",
                "Kepulauan Riau",
                "Riau",
                "Papua Barat",
                "Papua",
                "Papua Tengah",
                "Nusa Tenggara Timur",
                "Nusa Tenggara Barat",
                "Maluku Utara",
                "Maluku",
                "Lampung",
                "Kalimantan Utara",
                "Kalimantan Timur",
                "Kalimantan Tengah",
                "Kalimantan Selatan",
                "Kalimantan Barat",
                "Jawa Timur",
                "Jawa Tengah",
                "Jawa Barat",
                "Jambi",
                "DKI Jakarta",
                "Gorontalo",
                "Papua Barat Daya",
                "Papua Pegunungan",
                "Bengkulu",
                "Banten",
                "Kep. Bangka Belitung",
                "Bali",
                "Aceh",
                "Papua Selatan"              
            ],
            isTextWhite: true,
            isSplit: false,
        }
    },
    async mounted(){
        await this.getStats();
    },
    methods: {
        checkErrorForm(){
            if(
            this.formData.fullName == "" ||
            this.formData.nickName == "" ||
            this.formData.institution == "" ||
            this.formData.domicile == ""
            ){
                this.isErrorForm = true;
                return false;
            }
            this.isErrorForm = false;
            return true;
        },
        getTextColor(){
            console.log("ping");
            // let str = "option-"
            // str = str + this.formData.type;
            return "black";
        },
        checkErrorType(){
            if(this.formData.type == 0
            ){
                this.isErrorType = true;
                return false;
            }
            this.isErrorType = false;
            return true;
        },
        async uploadImage(e) {
            const image = e.target.files[0];
            const reader = new FileReader();
            reader.readAsDataURL(image);
            reader.onload = e => {
                var image = new Image();
                image.src = e.target.result;
                image.onload = () => {
                const {
                    height,
                    width,
                } = image;
                if (height != width) {
                    alert("Mohon pilih foto yang berbentuk persegi (square). Bila tidak, foto Anda akan tertarik/stretch dan tampak gepeng")
                    this.previewImage = e.target.result;
                    return false;
                }else{
                    this.previewImage = e.target.result;
                    var delayInMilliseconds = 2000; //1 second

                    setTimeout(function () {
                        //your code to be executed after 1 second
                    }, delayInMilliseconds);
                    return true;
                }
                }
            };
        },
        setOption(idname){
            if(this.currentClicked !== ""){
                document.getElementById(this.currentClicked).style.border = "2px solid #E4E7EB";
            }
            document.getElementById(idname).style.border = "4px solid #1F2933";
            this.currentClicked = idname;
            this.formData.type = idname.substring(3);
            console.log(this.formData.type);
        },
        async submitData(){
            console.log(this.checkErrorForm());
            console.log(this.checkErrorType());
            
            await this.postData();

            if(this.result == true){
                if(this.checkErrorForm() && this.checkErrorType()){

                    let spaceCount=0;

                    this.maxChar = Math.max(
                        this.formData.nickName.length,
                        this.formData.institution.length,
                        this.formData.domicile.length
                    );

                    if(this.maxChar >10){
                        this.isHsBig=false;
                        spaceCount = 20 - this.maxChar;
                    }else{
                        this.isHsBig=true;
                        spaceCount = 12 - this.maxChar;
                    }

                    if (spaceCount < 0){
                        spaceCount = 0;
                    }

                    let str = " ";
                    let multiSpace = str.repeat(spaceCount);

                    this.spacedData.nickName = multiSpace + this.formData.nickName;
                    this.spacedData.institution = multiSpace + this.formData.institution;
                    this.spacedData.domicile = multiSpace + this.formData.domicile;

                    // if(this.formData.type == 3 ||
                    // this.formData.type == 4 ||
                    // this.formData.type == 6 ||
                    // this.formData.type == 8 ||
                    // this.formData.type == 11 ||
                    // this.formData.type == 14 ||
                    // this.formData.type == 15 ||
                    // this.formData.type == 16 ||
                    // this.formData.type == 17 ||
                    // this.formData.type == 20 ||
                    // this.formData.type == 21 ||
                    // this.formData.type == 23 ||
                    // this.formData.type == 24
                    // ){
                    //     this.isHsWhite =true;
                    // }else{
                    //     this.isHsWhite =false;
                    // }

                    // const whites = [1,2,3,5,7,9,10,12,13,18,19,22,25,16]
                    // const blacks = [4,6,8,11,14,15,16,17,20,21,23,24]
                    if(this.formData.type == 1 ||
                        this.formData.type == 2 ||
                        this.formData.type == 3 ||
                        this.formData.type == 5 ||
                        this.formData.type == 7 ||
                        this.formData.type == 9 ||
                        this.formData.type == 10 ||
                        this.formData.type == 12||
                        this.formData.type == 13 ||
                        this.formData.type == 18 ||
                        this.formData.type == 19 ||
                        this.formData.type == 22 ||
                        this.formData.type == 25 ||
                        this.formData.type == 26 
                    ){
                        this.isTextWhite = true;
                        console.log("aaaaa")
                    }else{
                        this.isTextWhite = false;
                        console.log("bbbb")
                    }

                    if(this.formData.type == 4 ||
                    this.formData.type == 8 ){
                        this.isSplit = true;
                    }

                    this.state=1;
                    console.log("5")
                }
            }else{
                this.state=0;
            }


        },
        async postData(){
            console.log("1")
            console.log(this.formData)
            try{
                await axios.post(
                "https://api.worldcancerdays.com/api/sign",
                this.formData,
                {
                    headers: {
                    Accept: "application/json",
                }
                }
            ).then((response) => {
                console.log(response.data);
                if(response.data.data != null && response.data.data != undefined){
                    this.result=true;
                }
                console.log("2")
            })
            await this.getStats();
            }catch(e){
                alert("Mohon coba kembali, pastikan email Anda benar")
            }
            console.log("result")
            console.log(this.result)
        },
        async getStats(){
            await axios.get(
                "https://api.worldcancerdays.com/api/sign/stats",
                {
                    headers: {
                    Accept: "application/json",
                }
                }
            ).then((response) => {
                var data = response.data.stats.type;
                this.totalData = response.data.stats.total;
                this.stats = [];
                Object.keys(data).forEach(key => {
                    var val=data[key];
                    var str= "option-item2 p-3 m-2 option-" + key;
                    var name=this.cancerNames[key];
                    var newObj = {
                        'type':key,
                        'number':val,
                        'classString': str,
                        'cancerName': name,
                        'handColorIsBlack':this.handIconColorBlack[key]
                    }
                    this.stats.push(newObj);
                });
                console.log(this.stats)
            })
        },
        downloadHandSign() {
            var delayInMilliseconds = 1000; //1 second

            setTimeout(function () {
                //your code to be executed after 1 second
            }, delayInMilliseconds);

            domtoimage.toJpeg(document.getElementById('capture2'), {
                quality: 1,
            }).then(() => {
                domtoimage
                    .toJpeg(document.getElementById('capture2'), {
                        quality: 1,
                    })
                    .then(() => {
                        domtoimage
                            .toJpeg(document.getElementById('capture2'), {
                                quality: 1,
                            })
                            .then(function (dataUrl) {
                                var link = document.createElement('a');
                                link.download = 'image.jpeg';
                                link.href = dataUrl;
                                link.click();
                            });
                    });
            });
        },
        downloadPoster() {
            var delayInMilliseconds = 1000; //1 second

            setTimeout(function () {
                //your code to be executed after 1 second
            }, delayInMilliseconds);

            domtoimage.toJpeg(document.getElementById('capture'), {
                quality: 1,
            }).then(() => {
                domtoimage
                    .toJpeg(document.getElementById('capture'), {
                        quality: 1,
                    })
                    .then(() => {
                        domtoimage
                            .toJpeg(document.getElementById('capture'), {
                                quality: 1,
                            })
                            .then(function (dataUrl) {
                                var link = document.createElement('a');
                                link.download = 'image.jpeg';
                                link.href = dataUrl;
                                link.click();
                            });
                    });
            });
        }
    }
}
</script>

  <!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
@import url('https://fonts.googleapis.com/css?family=Poppins');
@font-face {
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: normal;
  src: url(https://themes.googleusercontent.com/static/fonts/opensans/v8/cJZKeOuBrn4kERxqtaUH3aCWcynf_cDxXwCLxiixG1c.ttf) format('truetype');
}
@font-face {
  font-family: 'Josefin Sans';
  font-style: normal;
  font-weight: normal;
  src: url(https://themes.googleusercontent.com/static/fonts/josefinsans/v3/xgzbb53t8j-Mo-vYa23n5onF5uFdDttMLvmWuJdhhgs.ttf) format('truetype');
}
@font-face {
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 400;
  src: url(~@/assets/Poppins-Regular.ttf) format('truetype');
  unicode-range: U+0900-097F, U+1CD0-1CF6, U+1CF8-1CF9, U+200C-200D, U+20A8, U+20B9, U+25CC, U+A830-A839, U+A8E0-A8FB;
}

.minilogo{
    width: 27px;
    height: 28px;
}

.biglogo{
    width: 45px;
    height: 48px;
}

.hs-text{
    font-size: 38px;
    font-weight:bolder;
    top: 500px;
    transform: rotate(-8deg);
    text-align: center;
    z-index: 3;
    font-family: 'Josefin Sans';
    margin: auto;
    position: absolute;
    top: 0; left: 90px; bottom: 0; right: 0;
    top: 520px;
    max-width: 800px;
    max-height: 300px;
}

.home-main-div {
    background-color: #F5F7FA;
    font-family: 'Poppins';
    color: #7B8794;
    box-sizing: unset;
}

.is-split {
    background-color: black;
    color: white;
}

.cancer-item-container {
    display: flex;
    flex-flow: row;
    overflow: auto;
}

.text-white {
    color: white;
	text-shadow: -1px 1px 2px #000, 1px 2px 6px #000, 1px -1px 0 #000,-1px -1px 0 #000;
}

.text-black {
    color: #03375C;
    text-shadow: -1px 1px 2px #FFFFFF, 1px 2px 6px #FFFFFF, 1px -1px 0 #FFFFFF,-1px -1px 0 #FFFFFF;
}

.color-1 {
    color: #F3E06D;
}

.option-1 {
    background: #F3E06D;
    color: #002E4C;
}
.option-2 {
    background: #A6A6A6;
    color: #002E4C;
}
.option-3 {
    background: #E05493;
    color: #FFFFFF;
}
.option-4 {
    background: linear-gradient(180deg, #3199AD 0%, rgba(49, 153, 173, 0) 132.87%);;
    color: #FFFFFF;
}
.option-5 {
    background: #EBBB28;
    color: #002E4C;
}
.option-6 {
    background: #0D25A1;
    color: #FFFFFF;
}
.option-7 {
    background: #D1C2D9;
    color: #002E4C;
}
.option-8 {
    background: linear-gradient(180deg, #8B2222 0%, rgba(209, 209, 209, 0) 132.87%);;
    color: #FFFFFF;
}
.option-9 {
    background: #FB9338;
    color: #002E4C;
}
.option-10 {
    background: #FFA300;
    color: #002E4C;
}
.option-11 {
    background: #09733C;
    color: #FFFFFF;
}
.option-12 {
    background: #F1F3F1;
    color: #002E4C;
}
.option-13 {
    background: #25F127F1;
    color: #002E4C;
}
.option-14 {
    background: #000000;
    color: #FFFFFF;
}
.option-15 {
    background: #8B2222;
    color: #FFFFFF;
}
.option-16 {
    background: #027F81;
    color: #FFFFFF;
}
.option-17 {
    background: #9A3C90;
    color: #FFFFFF;
}
.option-18 {
    background: #75DFF6;
    color: #002E4C;
}
.option-19 {
    background: #9290C3;
    color: #002E4C;
}
.option-20 {
    background: #EF0297;
    color: #FFFFFF;
}
.option-21 {
    background: linear-gradient(180deg, #1023A3 0%, #DF5491 51.69%, #309BAF 100%);;
    color: #FFFFFF;
}
.option-22 {
    background: #FEDBB7;
    color: #002E4C;
}
.option-23 {
    background: #80007E;
    color: #FFFFFF;
}
.option-24 {
    background: #AA54C4;
    color: #FFFFFF;
}
.option-25 {
    background: #FDFF0A;
    color: #002E4C;
}
.option-26 {
    background: #D0C3F1;
    color: #002E4C;
}

.option-item {
    display: flex;
    width: fit-content;
    border-radius: 20px;
    border: 2px solid #E4E7EB;
    box-shadow: 0px 4px 40px rgba(0, 0, 0, 0.05);
    border-radius: 20px;
    font-family: 'Poppins';
    white-space: nowrap;
}
.option-item2 {
    width: fit-content;
    border-radius: 20px;
    border: 2px solid #E4E7EB;
    box-shadow: 0px 4px 40px rgba(0, 0, 0, 0.05);
    border-radius: 20px;
    font-family: 'Poppins';
    white-space: nowrap;
}
.form-container {
    background-color: white;
    border-radius: 20px;
    background: #FFFFFF;
    border: 2px solid #E4E7EB;
    box-shadow: 0px 4px 40px rgba(0, 0, 0, 0.05);
    border-radius: 20px;
    font-family: 'Poppins';
    color: #7B8794;
}

.result-container {
    background-color: white;
    border-radius: 20px;
    background: #FFFFFF;
    border: 2px solid #E4E7EB;
    box-shadow: 0px 4px 40px rgba(0, 0, 0, 0.05);
    border-radius: 20px;
    font-family: 'Poppins';
    color: #7B8794;
    min-height: 1200px;
}

.result-container-2 {
    background-color: white;
    border-radius: 20px;
    background: #FFFFFF;
    border: 2px solid #E4E7EB;
    box-shadow: 0px 4px 40px rgba(0, 0, 0, 0.05);
    border-radius: 20px;
    font-family: 'Poppins';
    color: #7B8794;
    min-height: 800px;
}

.cancer-item {
    display: flex;
    background-color: white;
    width: fit-content;
    border-radius: 20px;
    background: #FFFFFF;
    border: 2px solid #E4E7EB;
    box-shadow: 0px 4px 40px rgba(0, 0, 0, 0.05);
    border-radius: 20px;
    font-family: 'Poppins';
    color: #7B8794;
}

.number {
    font-family: 'Poppins';
    font-weight: 900;
}

.total-count {
    font-size: 7rem;
    font-weight: 900;
    font-family: 'Poppins';
    color: #002E4C;
}

.total-count-desc {
    font-family: 'Poppins';
    font-weight: 50;
    color: #F06C39;
}

.desc-highlight {
    background-color: #F06C39;
    color: white;
    padding-left: 0.7%;
    padding-right: 0.7%;
    font-weight: 800;
}

.uploading-image {
    display: flex;
    z-index: 1;
    max-height: 1000px;
    max-width: 1000px;
}

.uploading-image-hands {
    position: absolute;
    z-index: 2;
    max-height: 1000px;
    /* max-width: 1000px; */
    margin-left: -480px;
    margin-top: -20px;
    transform: scaleX(-1);
}

.bottom-left {
    position: absolute;
    bottom: 100px;
    left: 100px;
}

.frame {
    width: 100%;
    min-width: 1000px;
    max-width: 1000px;
    height: auto;
    position: relative;
}

.frame2 {
    width: 100%;
    min-width: 1000px;
    max-width: 1000px;
    height: auto;
    position: relative;
}

.frame img {
    height: auto;
    width: inherit;
    position: absolute;
    left: 0;
}

.twibbon {
    z-index: 2;
}

.greetings {
    top: 720px;
    left: 30px;
    position: absolute;
    z-index: 3;
    font-family: 'Open Sans';
    font-weight: 900;
    font-size: 30px;
    /* color: #E4E7EB; */
}

.greetings2 {
    left: 180px;
    position: absolute;
    z-index: 3;
    font-family: 'Open Sans';
    white-space: pre
}

.big{
    top: 440px;
    font-weight: 900;
    font-size: 30px;
}

.small{
    top: 460px;
    font-weight: 900;
    font-size: 22px;
}

.textblack{
    color: black;
}

.textwhite{
    color: white;
}
</style>
